import React, { useEffect, useState } from 'react';

import { CharacterSheetInterface, Tool } from "@dndModels";

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import DataUtilities from '@dndUtilities/data_utilities';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterToolProfCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderToolProfCustomization = (tool: Tool) => {
    // debugger;
    const proficient = char.mind.tool_proficiencies.find(o => o.proficiency_id === tool._id);
    return (
      <FlexBox key={tool._id}>
        <FlexBox direction="row">
          <FlexBox xs_expand={0} style={{ width: "30%"}}>
            <FlexBox direction="column">
              <FlexBox>{ tool.name }</FlexBox>
              { proficient && 
                <FlexBox className="small_label gray">Proficient</FlexBox>
              }
              { customizations.tool_prof_overrides[tool._id] !== undefined &&
                <FlexBox className="small_label gray">Overridden</FlexBox>
              }
            </FlexBox>
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Override"
              value={ customizations.tool_prof_overrides[tool._id] === undefined ? "Don't Override" : (customizations.tool_prof_overrides[tool._id] ? "true" : "false") } 
              options={[{ id: "true", text: "Proficient" }, { id: "false", text: "Not Proficient" }]}
              extra_options={["Don't Override"]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Override") {
                  delete customizations.tool_prof_overrides[tool._id];
                } else {
                  customizations.tool_prof_overrides[tool._id] = changed === "true";
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
    );
  }

  
  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      { data_util.tools.map(tool => renderToolProfCustomization(tool))}
    </FlexBox>
  );
}

